/**
 * Resolve an entity's id across the Mongo→Postgres migration.
 *
 * Postgres/Prisma exposes the primary key as `id`; legacy Mongo records used
 * `_id`. Always prefer `id` and fall back to `_id`. Returns a string (ids are
 * used in URLs, query keys, and request payloads) or `undefined` when neither
 * is present, so callers can guard with a simple falsy check.
 */
export const getEntityId = (
  entity: { id?: unknown; _id?: unknown } | null | undefined
): string | undefined => {
  if (!entity) return undefined;
  const norm = (v: unknown): string | undefined =>
    v === null || v === undefined || v === '' ? undefined : String(v);
  return norm(entity.id) ?? norm(entity._id);
};

export default getEntityId;
